'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _animationFunctions = require('./utils/animationFunctions');

Object.defineProperty(exports, 'animation', {
  enumerable: true,
  get: function get() {
    return _animationFunctions.animationFunctions;
  }
});

var _backgroundFunctions = require('./utils/backgroundFunctions');

Object.defineProperty(exports, 'background', {
  enumerable: true,
  get: function get() {
    return _backgroundFunctions.backgroundFunctions;
  }
});

var _borderFunctions = require('./utils/borderFunctions');

Object.defineProperty(exports, 'border', {
  enumerable: true,
  get: function get() {
    return _borderFunctions.borderFunctions;
  }
});

var _clasificationFunctions = require('./utils/clasificationFunctions');

Object.defineProperty(exports, 'clasification', {
  enumerable: true,
  get: function get() {
    return _clasificationFunctions.clasificationFunctions;
  }
});

var _dimensionFunctions = require('./utils/dimensionFunctions');

Object.defineProperty(exports, 'dimension', {
  enumerable: true,
  get: function get() {
    return _dimensionFunctions.dimensionFunctions;
  }
});

var _flexboxFunctions = require('./utils/flexboxFunctions');

Object.defineProperty(exports, 'flexbox', {
  enumerable: true,
  get: function get() {
    return _flexboxFunctions.flexboxFunctions;
  }
});

var _fontFunctions = require('./utils/fontFunctions');

Object.defineProperty(exports, 'font', {
  enumerable: true,
  get: function get() {
    return _fontFunctions.fontFunctions;
  }
});

var _listFunctions = require('./utils/listFunctions');

Object.defineProperty(exports, 'list', {
  enumerable: true,
  get: function get() {
    return _listFunctions.listFunctions;
  }
});

var _marginFunctions = require('./utils/marginFunctions');

Object.defineProperty(exports, 'margin', {
  enumerable: true,
  get: function get() {
    return _marginFunctions.marginFunctions;
  }
});

var _otherFunctions = require('./utils/otherFunctions');

Object.defineProperty(exports, 'other', {
  enumerable: true,
  get: function get() {
    return _otherFunctions.otherFunctions;
  }
});

var _overflowFunctions = require('./utils/overflowFunctions');

Object.defineProperty(exports, 'overflow', {
  enumerable: true,
  get: function get() {
    return _overflowFunctions.overflowFunctions;
  }
});

var _paddingFunctions = require('./utils/paddingFunctions');

Object.defineProperty(exports, 'padding', {
  enumerable: true,
  get: function get() {
    return _paddingFunctions.paddingFunctions;
  }
});

var _positionFunctions = require('./utils/positionFunctions');

Object.defineProperty(exports, 'position', {
  enumerable: true,
  get: function get() {
    return _positionFunctions.positionFunctions;
  }
});

var _textFunctions = require('./utils/textFunctions');

Object.defineProperty(exports, 'text', {
  enumerable: true,
  get: function get() {
    return _textFunctions.textFunctions;
  }
});

var _transformFunctions = require('./utils/transformFunctions');

Object.defineProperty(exports, 'transform', {
  enumerable: true,
  get: function get() {
    return _transformFunctions.transformFunctions;
  }
});

var _transitionFunctions = require('./utils/transitionFunctions');

Object.defineProperty(exports, 'transition', {
  enumerable: true,
  get: function get() {
    return _transitionFunctions.transitionFunctions;
  }
});

function _toArray(arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Responsively = function () {
  function Responsively() {
    var _this = this;

    _classCallCheck(this, Responsively);

    this.responsive = function () {
      var cssProperty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return function () {
        var cssValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var _cssValues = _toArray(cssValues),
            defaultValue = _cssValues[0],
            responsiveValues = _cssValues.slice(1);

        var unitlessProperties = ['animation-iteration-count', 'border-image-slice', 'border-image-width', 'column-count', 'counter-increment', 'counter-rese', 'flex', 'flex-grow', 'flex-shrink', 'font-size-adjust', 'font-weight', 'line-height', 'nav-index', 'opacity', 'order', 'orphans', 'tab-size', 'widows', 'z-index', 'pitch-range', 'richness', 'speech-rate', 'stress', 'volume', 'flood-opacity', 'mask-box-outset', 'mask-border-outset', 'mask-box-width', 'mask-border-width', 'shape-image-threshold'];

        var parseValue = function parseValue(value) {
          if (unitlessProperties.indexOf(cssProperty) > -1) {
            return value;
          } else if (/^[\d\s]+$/.test(value)) {
            return value.toString().split(' ').map(function (shorthandArgs) {
              return shorthandArgs.replace(/\D/g, '') + 'px';
            }).join(' ');
          }

          return value;
        };

        var parseBreakpointValue = function parseBreakpointValue(value) {
          if (/^[\d\s]+$/.test(value)) {
            return value.toString().split(' ').map(function (shorthandArgs) {
              return shorthandArgs.replace(/\D/g, '') + 'px';
            }).join(' ');
          }

          return value;
        };
        /* eslint-disable no-confusing-arrow */


        var renderBreakpoints = function renderBreakpoints(value, index) {
          return value ? '@media screen and (min-width: ' + parseBreakpointValue(_this.breakpointValues[index]) + ') {\n          ' + cssProperty + ': ' + parseValue(value) + ';\n        }' : '';
        };

        var defaultStyle = function defaultStyle() {
          return defaultValue ? cssProperty + ': ' + parseValue(defaultValue) + ';' : '';
        };
        /* eslint-enable no-confusing-arrow */


        var responsiveStyles = function responsiveStyles() {
          var responsiveStylesArray = [];

          for (var i = 0; i < responsiveValues.length; i += 1) {
            responsiveStylesArray.push(renderBreakpoints(responsiveValues[i], i));
          }

          return responsiveStylesArray.toString().split(',').join(' ');
        };

        if (cssValues.length > _this.breakpointValues.length + 1) {
          /* eslint-disable-next-line max-len, no-console */
          return console.warn('This function accepts ' + (_this.breakpointValues.length + 1) + ', while you entered ' + cssValues.length + " arguments.\n      \xAF\\_(\u30C4)_/\xAF Please check your resonsively function.");
        }

        return '' + defaultStyle() + responsiveStyles();
      };
    };

    this.breakpointValues = undefined;
  }

  _createClass(Responsively, [{
    key: 'configureBreakpoints',
    value: function configureBreakpoints(breakpointValues) {
      this.breakpointValues = breakpointValues;
    }
  }]);

  return Responsively;
}();

exports.default = new Responsively(); // Export props from utils folder.